import { IconButton, IconButtonProps } from "@/common/styles/style";
import ArrowBackOutlinedIcon from "@mui/icons-material/ArrowBackOutlined";
import { useNavigate } from "react-router-dom";
import { style } from "./style";

export default function BackButton(props: IconButtonProps) {
  const navigate = useNavigate();

  const goBack = () => {
    navigate(-1);
  };

  return (
    <IconButton onClick={goBack} sx={style} {...props}>
      <ArrowBackOutlinedIcon />
    </IconButton>
  );
}
